<template>
  <div id="settingsInplace">
    <Tabs>

      <TabSection :title="$t('settings.tables')" v-if="config.inPlace">
        <TipBox info :title="$t('tips.tables.title')">
          <span v-html="$t('tips.tables.description')"></span>
        </TipBox>
        <div class="group">
          <label>{{ $t("settings.table_list") }}</label>
          <VueSelect multiple v-model="config.inPlace.tables" taggable :closeOnSelect="false">
            <span slot="no-options">{{ $t("settings.tables_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <TabSection :title="$t('qr_payment.qr_code.title')" v-if="!!$route.query.company">
        <QrCodeGenerator :url="frontendUrl + '?method=inPlace'" :urls="tableUrls"
          :description="$t('qr_payment.qr_code.in_place_description')"></QrCodeGenerator>
      </TabSection>

      <TabSection :title="$t('settings.general')" v-if="config.inPlace" class="general">
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.delay") }}</label>
              <input type="number" v-model="config.inPlace.general.averageDelay">
            </div>
            <div class="group" v-if="permissions.tipsActivated">
              <div class="subtitle">{{ $t('settings.tip') }}</div>
              <TipBox no-border info>
                <span v-html="$t('tips.tip')"></span>
              </TipBox>
              <label>{{ $t("settings.tip") }}</label>
              <select v-model="config.inPlace.general.tipsActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>

            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.service_fee") }}</span>
            </div>
            <TipBox info no-border>
              <span v-html="$t('tips.service_fees')"></span>
            </TipBox>
            <div class="group">
              <label>{{ $t("settings.amount") }} ({{ currencySymbol }})</label>
              <input type="number" v-model="config.inPlace.general.serviceFees.amount">
            </div>
          </div>
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.order_amount") }}</span>
            </div>
            <TipBox danger no-border>
              <span v-html="$t('tips.minimum_amount')"></span>
            </TipBox>
            <div class="columns">
              <div class="column group">
                <label>{{ $t("settings.minimum_amount") }} ({{ currencySymbol }})</label>
                <input type="number" v-model="config.inPlace.general.minimumPrice">
              </div>
              <!--<div class="column group">
                <label>{{$t("settings.maximum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.inPlace.general.maximumPrice">
              </div>-->
            </div>
            <!--
            <div class="subtitle">
              <span class="flex-grow">{{$t("settings.order_clients")}}</span>
            </div>
            <div class="columns">
              <div class="column group">
                <label>{{$t("settings.minimum_clients")}}</label>
                <input type="number" v-model="config.inPlace.general.minimumMeals">
              </div>
              <div class="column group">
                <label>{{$t("settings.maximum_clients")}}</label>
                <input type="number" v-model="config.inPlace.general.maximumMeals">
              </div>
            </div>
            -->
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('open_hours')" v-if="cascader && config.inPlace">
        <TipsOpenHours />
        <div id="editOpenHoursContainerInPlace" class="group">
          <input id="editOpenHoursInPlace" type="checkbox" v-model="config.inPlace.editOpenHours">
          <label for="editOpenHoursInPlace">{{ $t("settings.edit_open_hours") }}</label>
        </div>
        <div class="columns" :class="{ openHoursDisabled: !config.inPlace.editOpenHours }">
          <div class="column">
            <DayTimeRange :day="cascader.get('inPlace.hours.monday').value" dayName="monday" context="inPlace"
              errorsKey="config.inPlace.hours.monday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('inPlace.hours.tuesday').value" dayName="tuesday" context="inPlace"
              errorsKey="config.inPlace.hours.tuesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('inPlace.hours.wednesday').value" dayName="wednesday" context="inPlace"
              errorsKey="config.inPlace.hours.wednesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('inPlace.hours.thursday').value" dayName="thursday" context="inPlace"
              errorsKey="config.inPlace.hours.thursday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
          <div class="column">
            <DayTimeRange :day="cascader.get('inPlace.hours.friday').value" dayName="friday" context="inPlace"
              errorsKey="config.inPlace.hours.friday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('inPlace.hours.saturday').value" dayName="saturday" context="inPlace"
              errorsKey="config.inPlace.hours.saturday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('inPlace.hours.sunday').value" dayName="sunday" context="inPlace"
              errorsKey="config.inPlace.hours.sunday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
        </div>
      </TabSection>

      <!-- <Panel :title="$t('message')" v-if="config.inPlace" collapsible>
        <div class="group">
          <label>{{$t("settings.service_message")}}</label>
          <textarea v-model="config.inPlace.onEnterMessage.message.fr"
            :class="{invalid: parentValidate.error('config.inPlace.onEnterMessage.message.fr')}"></textarea>
        </div>
        <div class="group">
          <input id="chkPopup" type="checkbox" v-model="config.inPlace.onEnterMessage.type" true-value="popup" :false-value="null">
          <label for="chkPopup">Afficher ce message dans une fenêtre</label>
        </div>
      </Panel> -->

      <TabSection :title="$t('notifications')" v-if="config.inPlace">
        <TipsNotification />
        <div class="subtitle">
          <span class="flex-grow">{{ $t("settings.on_sale_notification") }}</span>
        </div>
        <TipBox warning v-if="!isSMSactivated" no-border>
          <div v-html="$t('tips.sms_feature.disabled')"></div>
        </TipBox>
        <div class="group" :class="{ locked: !isSMSactivated }">
          <label>{{ $t("settings.sms_notification") }}</label>
          <VueSelect multiple v-model="config.inPlace.notifications.onSale.sms" taggable>
            <span slot="no-options">{{ $t("settings.sms_tip") }}</span>
          </VueSelect>
        </div>
        <div class="group">
          <label>{{ $t("settings.email_notification") }}</label>
          <VueSelect multiple v-model="config.inPlace.notifications.onSale.emails" taggable>
            <span slot="no-options">{{ $t("settings.email_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <!--
      <Panel :title="$t('settings.questions')">
        <template v-for="(question, qIndex) of config.inPlace.questions">
          <div class="subtitle">
            <span class="flex-grow">{{$t("settings.question") + ' #' + (qIndex + 1)}}</span>
          </div>
          <LocalizedInput :translate="question" />
          <div class="question-options">
            <div class="group">
              <input :id="`inp_q_opt_${qIndex}`" type="checkbox" v-model="question.optional">
              <label :for="`inp_q_opt_${qIndex}`">{{$t("optional")}}</label>
            </div>
            <button class="btn btn-primary" @click="removeQuestion(qIndex)">X</button>
          </div>
        </template>
        <button class="btn btnAddQuestion btn-primary" @click="addQuestion">
          {{$t('settings.add_question')}}
          <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
        </button>
      </Panel>
      -->
    </Tabs>

    <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
      <button class="btn btn-primary" @click="$emit('save')">{{ $t("save") }}</button>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import Cascader from "@/resources/cascader";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import VueSelect from 'vue-select';
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import TipsNotification from "@/components/tips/TipsNotification.vue";
  import TipsOpenHours from "@/components/tips/TipsOpenHours.vue";
  import QrCodeGenerator from "@/components/QrCodeGenerator.vue";

  export default {

    name: "SettingsInplace",

    props: {
      config: Object,
      parentConfig: Object,
      parentValidate: Object,
      permissions: Object,
      currencySymbol: {
        type: String,
        default: '$'
      }
    },

    components: { VueSelect, DayTimeRange, LocalizedInput, TipsNotification, TipsOpenHours, QrCodeGenerator },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);

      let urlFrontend = this.$store.state.contextServer.urlFrontend;
      let company = await this.$store.getters.getContextCompany;
      let branch = await this.$store.getters.getContextBranch;
      this.frontendUrl = urlFrontend + "/#/" + branch.nameCanonical + "/" + company.nameCanonical + "/menu";
    },

    data() {
      return {
        cascader: null,
        frontendUrl: null,
      }
    },

    computed: {
      isSMSactivated() {
        return this.$store.state.contextCompany && this.$store.state.contextCompany.smsActivated;
      },
      tableUrls() {
        return this.config.inPlace.tables.map(table => {
          return {
            filename: 'table-' + table,
            url: this.frontendUrl + "?table=" + table
          }
        });
      }
    },

    watch: {
      "config.inPlace.editOpenHours": function (edit, old) {
        if (old === undefined) {
          return;
        }
        if (edit) {
          Vue.set(this.config.inPlace, "hours", this._copy(this.parentConfig.inPlace.hours));
        } else {
          Vue.delete(this.config.inPlace, "hours");
        }
        this.$forceUpdate();
      }
    },

    methods: {
      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      addQuestion() {
        this.config.inPlace.questions.push({
          fr: null,
          en: null,
          optional: false
        })
      },
      removeQuestion(index) {
        this.config.inPlace.questions.splice(index, 1)
      }
    }

  }
</script>

<style lang="scss" scoped>
  #settingsInplace {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .general {
    .subtitle {
      padding-top: 10px;
    }
  }

  #editOpenHoursContainerInPlace,
  #activateInAdvanceContainerInPlace {
    label {
      color: #404040;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .openHoursDisabled {
    opacity: 0.7;
    pointer-events: none;
  }

  input {
    width: 100%;
  }

  .question-options {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .btnAddQuestion {
    display: flex;
    align-items: center;
    fill: white;

    .svgicon {
      margin-left: 10px;
    }
  }
</style>